import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d775b75")

_pushScopeId("data-v-3d775b75")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增职位", -1)
const _hoisted_4 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = { class: "c-ff" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx._addinfo
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "180"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", {
                  class: "btn-red",
                  onClick: ($event: any) => (_ctx._editinfo(scope.row.position_id, scope.row.position_name, scope.row.sort))
                }, " 修改 ", 8, ["onClick"]),
                _createVNode("div", {
                  class: "btn-red-line mar-l-2",
                  onClick: ($event: any) => (_ctx._uprowStatus(scope.row.position_id, scope.row.position_status))
                }, _toDisplayString(scope.row.position_status == 1 ? '禁用' : '启动'), 9, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.dialog_title,
      modelValue: _ctx.dialog_show,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog_show = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx._formSubmit
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.dialog_title == '修改部门' ? '保存': '增加'), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.form,
            rules: _ctx.form_rules,
            "label-width": "80px",
            style: {"width":"300px","margin":"0 auto"}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, {
                label: "部门名称",
                prop: "position_name"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    class: "width-188",
                    modelValue: _ctx.form.position_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.position_name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "排序" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    class: "width-188",
                    modelValue: _ctx.form.sort,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.sort = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]), [
            [_directive_loading, _ctx.form_isload]
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
})